/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Millcot custom styles — injected once, applied site-wide */
(function () {
  var css = ''
    /* Prevent the compare-at ("was") price from clipping on product cards (mobile) */
    + '@media screen and (max-width: 740px){'
    +   '.product-item__price-list.price-list{display:flex;flex-wrap:wrap;align-items:baseline;column-gap:6px;row-gap:1px;overflow:visible;white-space:normal;}'
    +   '.product-item__price-list .price{white-space:nowrap;}'
    +   '.product-item__price-list .price--highlight,.product-item__price-list .price--compare{font-size:1.5rem;}'
    + '}'
    /* Tidy the collection "Sort by" menu — hide the Date, old to new / new to old options */
    + '[data-action="select-value"][data-value="created-ascending"],[data-action="select-value"][data-value="created-descending"]{display:none !important;}';
  var style = document.createElement('style');
  style.setAttribute('data-millcot', 'custom');
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);
})();
